export default "__VITE_PUBLIC_ASSET__eb86714a__"